"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = require("events");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var applyMiddlewares = function applyMiddlewares(middlewares, nextState) {
  return middlewares.reduce(function (s, next) {
    return next(s);
  }, nextState);
};

var PromisedReducer = function (_EventEmitter) {
  _inherits(PromisedReducer, _EventEmitter);

  function PromisedReducer(initialState) {
    var middlewares = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];

    _classCallCheck(this, PromisedReducer);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PromisedReducer).call(this));

    _this.state = initialState ? initialState : {};
    _this.middlewares = middlewares ? middlewares : [];

    _this.updating = false;
    _this._updatingQueue = []; // TODO
    _this._updatingPromise = null;
    return _this;
  }

  _createClass(PromisedReducer, [{
    key: "_finishUp",
    value: function _finishUp(nextState) {
      var inAsync = !!this._updatingPromise;

      if (inAsync) {
        this._updatingQueue.length = 0;
        this._updatingPromise = null;
        this.updating = false;
      }

      this.state = nextState;
      this.emit(":update", this.state);

      if (inAsync) {
        this.emit(":end-anync-updating");
      }
      return Promise.resolve();
    }
  }, {
    key: "update",
    value: function update(nextStateFn) {
      var _this2 = this;

      // if app is updating, add fn to queues and return current promise;
      if (this.updating) {
        this._updatingQueue.push(nextStateFn);
        return this._updatingPromise;
      }

      // Create state
      var promiseOrState = applyMiddlewares(this.middlewares, nextStateFn(this.state));

      // if state is not promise, exec and resolve at once.
      if (!(promiseOrState instanceof Promise)) {
        var oldState = this.state;
        this._finishUp(promiseOrState);
        this.emit(":process-updating", this.state, oldState);
        return Promise.resolve();
      }

      // start async updating!
      this.updating = true;
      this.emit(":start-async-updating");

      // create callback to response.
      // TODO: I want Promise.defer
      var endUpdate;
      this._updatingPromise = new Promise(function (done) {
        endUpdate = done;
      });

      // drain first async
      var lastState = this.state;
      promiseOrState.then(function (nextState) {
        _this2.emit(":process-async-updating", nextState, lastState);

        // if there is left queue after first async,
        var updateLoop = function updateLoop(appliedState) {
          var nextFn = _this2._updatingQueue.shift();
          if (nextFn == null) {
            _this2._finishUp(appliedState);
            endUpdate();
            return;
          } else {
            return Promise.resolve(applyMiddlewares(_this2.middlewares, nextFn(appliedState))).then(function (s) {
              _this2.emit(":process-async-updating", s, appliedState, _this2._updatingQueue.length);
              _this2.emit(":process-updating", s, appliedState);
              updateLoop(s); // recursive loop
            });
          }
        };
        updateLoop(nextState);
      });

      return this._updatingPromise;
    }
  }]);

  return PromisedReducer;
}(_events.EventEmitter);

exports.default = PromisedReducer;
